import { Component, ViewChild, OnInit, Inject, ElementRef } from "@angular/core";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { AnalyticsService } from "./features/fnol/services/analytics.service";
import { FnolService } from "./features/fnol/services/fnol.service";
import { FOOTERMAPPING } from "./features/fnol/config/footer-links-constants";
import { AppConfig } from "./shared/config";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
//test
export class AppComponent implements OnInit {
  country: string;
  public pauseTimer = false;
  
  // Generated by AIG Copilot - start
  @ViewChild('modalPolicyFooter') modalPolicyFooter: any;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  hasScrolledToBottom: boolean = false;
  privacyLinks: { label: string; link: string }[] = [];
  public readonly SCROLL_POSITION_FOOTER_KEY = 'axis_modal_footer_scroll_position';
  // Generated by AIG Copilot - end
  
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private fnolService: FnolService,
    public config: AppConfig
  ) {
  }

  ngOnInit() {
    this.analyticsService.addAnalyticsURL();

    this.country = this.route.snapshot.paramMap.get('country');

    const path = window.location.href.split("/");
    this.country = path.at(-1);
    console.log(this.router.url);
    
    // Generated by AIG Copilot - start
    // Subscribe to footer modal trigger for special countries
    this.fnolService.notificationObligationsModal.subscribe(openModal => {
      if (openModal) {
        this.hasScrolledToBottom = false;
        this.updatePrivacyLinks();
        this.modalPolicyFooter.open();
        
        // Restore scroll position after footer modal opens
        setTimeout(() => {
          this.restoreScrollPosition('modalPolicyFooter');
        }, 100);
        
        this.fnolService.notificationObligationsModal.next(false);
      }
    });
    
    // Update privacy links when country changes
    this.fnolService.landingSelectedCountry.subscribe(selectedCountry => {
      if (selectedCountry && AppConfig.countryConfig[selectedCountry.code.toLowerCase()]) {
        this.updatePrivacyLinks(selectedCountry.code.toLowerCase());
        // Reset scroll state when country changes
        this.resetScrollState();
      }
    });
    // Generated by AIG Copilot - end
  }
  

  /**
   * Check if current country is a special country that requires scroll logic
   */
  isSpecialCountry(): boolean {
    const specialCountries = ['at', 'de', 'ch'];
    const currentCountry = window.location.pathname.split('/')[2]?.toLowerCase() || '';
    return specialCountries.includes(currentCountry);
  }
  
  /**
   * Update privacy links based on current country
   */
  updatePrivacyLinks(countryCode?: string): void {
    const country = countryCode || window.location.pathname.split('/')[2]?.toLowerCase();
    if (country && AppConfig.countryConfig[country]) {
      const footerLink = FOOTERMAPPING().list;
      if (footerLink[country] && footerLink[country]['privacy']) {
        this.privacyLinks = footerLink[country]['privacy']['links'];
      }
    }
  }
  
  /**
   * Handle external link clicks
   */
  handleClick(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
   
  /**
   * Save scroll position when modal closes
   */
  saveScrollPosition(modalType: string): void {
    if (!this.scrollContainer || !this.scrollContainer.nativeElement) {
      return;
    }

    const scrollTop = this.scrollContainer.nativeElement.scrollTop;
    
    try {
      localStorage.setItem(this.SCROLL_POSITION_FOOTER_KEY, scrollTop.toString());
    } catch (error) {
      console.warn('Failed to save scroll position to localStorage:', error);
    }
  }
  
  /**
   * Restore scroll position when modal opens
   */
  private restoreScrollPosition(modalType: string): void {
    if (!this.scrollContainer || !this.scrollContainer.nativeElement) {
      return;
    }
    
    try {
      const savedScrollPosition = localStorage.getItem(this.SCROLL_POSITION_FOOTER_KEY);
      if (savedScrollPosition !== null) {
        const scrollTop = parseInt(savedScrollPosition, 10);
        if (!isNaN(scrollTop)) {
          this.scrollContainer.nativeElement.scrollTop = scrollTop;
        }
      }
    } catch (error) {
      console.warn('Failed to restore scroll position from localStorage:', error);
    }
  }
  
  /**
   * Reset scroll state when country changes
   */
  private resetScrollState(): void {
    // Reset scroll-related state variables
    this.hasScrolledToBottom = false;
    
    // Clear saved scroll position from localStorage
    try {
      localStorage.removeItem(this.SCROLL_POSITION_FOOTER_KEY);
    } catch (error) {
      console.warn('Failed to clear scroll position from localStorage:', error);
    }
    
    // Reset scroll position to top if modal is currently open
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.scrollTop = 0;
    }
  }
  // Generated by AIG Copilot - end
}
